<template>
  <section class="view rule-templates-view">
    <section class="surface">
      <div class="surface-head">
        <div>
          <h2>被分享的 Rule</h2>
          <span>{{ ruleTemplates.length }} 条公开 Rule</span>
        </div>
        <div class="surface-actions rule-template-actions">
          <el-select
            v-model="targetJobId"
            filterable
            clearable
            placeholder="选择导入到哪个 Job"
          >
            <el-option
              v-for="job in jobs"
              :key="job.id"
              :label="ruleJobOptionLabel(job)"
              :value="String(job.id)"
            />
          </el-select>
          <el-button :icon="icons.Refresh" @click="refreshRuleTemplates">
            刷新
          </el-button>
        </div>
      </div>

      <el-table
        :data="ruleTemplates"
        row-key="id"
        class="template-table"
        height="620"
        empty-text="暂无被分享的 Rule"
      >
        <el-table-column label="Rule" min-width="320" show-overflow-tooltip>
          <template #default="{ row }">
            <span class="rule-template-content">{{ row.rule || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="来源 Job" min-width="220">
          <template #default="{ row }">
            <div class="job-name">
              <strong>{{ row.step || '-' }}</strong>
              <span>{{ row.step_desc || '未填写描述' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="方式" width="92">
          <template #default="{ row }">
            <el-tag :type="methodTagType(row.http_type)" effect="light">
              {{ row.http_type || 'GET' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="分享人" width="150">
          <template #default="{ row }">
            <div class="template-owner">
              <span>{{ row.owner_username || '-' }}</span>
              <el-tag v-if="row.shared_by_me" size="small" effect="plain">我</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="168">
          <template #default="{ row }">{{ formatDateTime(row.updated_at) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="148" fixed="right">
          <template #default="{ row }">
            <el-button
              type="primary"
              size="small"
              :icon="icons.Download"
              :disabled="!targetJobId"
              :loading="copyingRuleTemplateId === Number(row.id)"
              @click="handleCopyRule(row.id)"
            >
              导入
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>
  </section>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { Download, Refresh } from "@element-plus/icons-vue";
import { formatDateTime, methodTagType, ruleJobOptionLabel } from "../utils/job-display";

export default {
  name: "RuleTemplatesPage",

  data() {
    return {
      icons: {
        Download,
        Refresh,
      },
      targetJobId: "",
    };
  },

  computed: {
    ...mapState(["jobs", "ruleTemplates", "copyingRuleTemplateId"]),
  },

  mounted() {
    this.refreshRuleTemplates();
  },

  methods: {
    ...mapActions(["loadJobs", "loadRuleTemplates", "copyRuleTemplate"]),
    formatDateTime,
    methodTagType,
    ruleJobOptionLabel,

    refreshRuleTemplates() {
      this.loadJobs();
      this.loadRuleTemplates();
    },

    handleCopyRule(id) {
      this.copyRuleTemplate({
        id,
        jobId: this.targetJobId,
      });
    },
  },
};
</script>
